module.exports = __webpack_public_path__ + "assets/img/nav.150d6ee9.png";